export const modelMapping = {
  "gpt-4o": "OpenAI",
  "gpt-4o-mini": "OpenAI",
  "o3-mini": "OpenAI",
  "claude-3.5-sonnet": "Claude",
  "gemini-2.0-flash": "Gemini",
  "gemini-1.5-flash": "Gemini",
  "gemini-1.5-pro": "Gemini",
  "Grok 3": "Grok",
  "Grok 2": "Grok",
  "Mixtral 8x22B": "Mistral",
  "Llama 4 Maverick": "Llama",
  "Llama 4 Scout": "Llama",
  "sonar-pro": "Perplexity",
  "V3": "Deepseek",
  "R1": "Deepseek",
  "Command A": "Cohere",
  "Command R7B": "Cohere",
  "Command R+": "Cohere",
  "Qwen-Max": "Other AI's",
  "Molmo": "Other AI's",
  "Krutrim": "Other AI's",
  "you.com": "Other AI's",
};

export const MODEL_ICONS = [
  // OpenAI SVG
  <svg
    key="openai"
    fill="#3f94ee"
    viewBox="0 0 24 24"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#3f94ee"
    width="24"
    height="24"
  >
    <g id="SVGRepo_iconCarrier">
      <title>OpenAI icon</title>
      <path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z"></path>
    </g>
  </svg>,

  // Claude SVG
  <svg
    key="claude"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 92.2 65"
    width="24"
    height="24"
    fill="#181818"
  >
    <path
      d="M66.5,0H52.4l25.7,65h14.1L66.5,0z M25.7,0L0,65h14.4l5.3-13.6h26.9L51.8,65h14.4L40.5,0C40.5,0,25.7,0,25.7,0z
       M24.3,39.3l8.8-22.8l8.8,22.8H24.3z"
    ></path>
  </svg>,
  // Google SVG
  <svg
    key="google"
    viewBox="-3 0 262 262"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
  >
    <path
      d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
      fill="#4285F4"
    ></path>
    <path
      d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
      fill="#34A853"
    ></path>
    <path
      d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"
      fill="#FBBC05"
    ></path>
    <path
      d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
      fill="#EB4335"
    ></path>
  </svg>,
  //GROQ SVG - Replaced with new icon
  <svg
    key="groq"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 841.89 595.28"
    width="24"
    height="24"
    fill="#000000"
  >
    <g>
      <polygon points="557.09,211.99 565.4,538.36 631.96,538.36 640.28,93.18" />
      <polygon points="640.28,56.91 538.72,56.91 379.35,284.53 430.13,357.05" />
      <polygon points="201.61,538.36 303.17,538.36 353.96,465.84 303.17,393.31" />
      <polygon points="201.61,211.99 430.13,538.36 531.69,538.36 303.17,211.99" />
    </g>
  </svg>,

  //MistralAi SVG
  <svg
  key="mistral"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    id="Mistral-Ai--Streamline-Svg-Logos"
    height="24"
    width="24"
  >
    <desc>Mistral Ai Streamline Icon: https://streamlinehq.com</desc>
    <path
      fill="#000000"
      d="M10.203975 9.5443h0.51285l0.2116 0.7652 0.0726 0.298575h0.0133l0.0717 -0.298575 0.212575 -0.7652h0.51285v2.15925h-0.41355v-0.66845l0.00025 -0.03485c0.003575 -0.255525 0.04345 -0.7454 0.06525 -0.968175h-0.009925l-0.16575 0.579575 -0.1681 0.520125h-0.2372l-0.17105 -0.520125 -0.154575 -0.579575h-0.011475l0.005275 0.05165c0.02485 0.2522 0.060225 0.724825 0.060225 0.951375v0.66845h-0.40685v-2.15925Zm2.043725 1.7495h0.5045v-1.33975h-0.5045v-0.409775h1.49785v0.409775h-0.50435v1.33975h0.50435v0.409775h-1.49785v-0.409775Zm1.910575 0.1377 0.2806 -0.335625c0.163325 0.13365 0.364825 0.225325 0.574275 0.225325 0.207475 0 0.3033 -0.0803 0.3033 -0.18585 0 -0.1555 -0.128425 -0.193075 -0.332825 -0.27865l-0.28145 -0.120075c-0.239325 -0.0909 -0.457925 -0.274375 -0.457925 -0.588675 0 -0.3576 0.3223 -0.643425 0.791775 -0.643425 0.259825 0 0.522375 0.0974 0.71745 0.2827l-0.246325 0.30805c-0.1522 -0.1092 -0.286825 -0.168675 -0.4979 -0.168675 -0.160975 0 -0.2703 0.06675 -0.2703 0.192825 0 0.1299 0.1448 0.177475 0.352025 0.2551l0.264275 0.111925c0.28295 0.106 0.4615 0.282375 0.4615 0.5871 0 0.35895 -0.30125 0.669725 -0.83605 0.669725 -0.291925 0 -0.593375 -0.106725 -0.822425 -0.311775Zm2.572 -1.47745h-0.647675v-0.409775h1.784225v0.409775H17.21925v1.749525h-0.488975v-1.749525Zm1.959 -0.021925h0.238375c0.2568 0 0.3946 0.071675 0.3946 0.2849 0 0.211375 -0.1378 0.321875 -0.3946 0.321875h-0.238375v-0.606775Zm1.215975 1.77145 -0.488575 -0.86385c0.23065 -0.10425 0.384975 -0.305425 0.384975 -0.6227 0 -0.5086 -0.3691 -0.66955 -0.8205 -0.6727l-0.7818 -0.00005v2.1593h0.489925v-0.7768h0.256625l0.412475 0.7768h0.546875Zm0.811575 -0.8943 0.051125 -0.198925 0.167625 -0.69635h0.01325c0.0371 0.16275 0.081275 0.338275 0.123425 0.50385l0.099825 0.391425h-0.45525Zm0.6834 0.89425h0.518425l-0.6729 -2.15925h-0.586025l-0.6729 2.15925h0.5003l0.1319 -0.513475h0.6502l0.131 0.513475Zm0.900325 -2.159225h0.487975v1.7495h0.96165v0.40975h-1.449625v-2.15925Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#000000"
      d="m10.77175 14.273175 0.051125 -0.198925 0.167625 -0.696425h0.01325c0.0371 0.16275 0.081275 0.338325 0.123425 0.503925l0.099825 0.391425h-0.45525Zm0.6832 0.8951h0.5186l-0.673125 -2.16015h-0.586275l-0.673125 2.16015h0.500475l0.132 -0.5138h0.6504l0.13105 0.5138Zm0.7927 -0.410575h0.5045v-1.3398h-0.5045v-0.409775h1.49785v0.409775h-0.504375v1.3398h0.504375v0.409775h-1.49785v-0.409775Zm1.9326 0.624675h1.600325v0.37215H14.18025v-0.37215Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#000000"
      d="M7.302475 8.245475h-1.4105v1.410525h1.4105v-1.410525Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#f7d046"
      d="M8.007925 8.245475h-1.410525v1.410525h1.410525v-1.410525Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#000000"
      d="M1.66052 8.245475H0.25v1.410525h1.41052v-1.410525Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#000000"
      d="M1.66052 9.656H0.25v1.410525h1.41052V9.656Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#000000"
      d="M1.66052 11.066475H0.25v1.4105h1.41052v-1.4105Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#000000"
      d="M1.66052 12.477H0.25v1.4105h1.41052v-1.4105Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#000000"
      d="M1.66052 13.887625H0.25v1.410525h1.41052v-1.410525Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#f7d046"
      d="M2.36584 8.245475H0.9553225v1.410525h1.4105175v-1.410525Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#f2a73b"
      d="M8.007925 9.656h-1.410525v1.410525h1.410525V9.656Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#f2a73b"
      d="M2.36584 9.656H0.9553225v1.410525h1.4105175V9.656Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#000000"
      d="M5.891975 9.656h-1.410525v1.410525h1.410525V9.656Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#f2a73b"
      d="M6.5974 9.656h-1.4105v1.410525h1.4105V9.656Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#f2a73b"
      d="M3.776375 9.656H2.365845v1.410525h1.41053V9.656Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#ee792f"
      d="M5.186875 11.066475h-1.4105v1.4105h1.4105v-1.4105Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#ee792f"
      d="M6.5974 11.066475h-1.4105v1.4105h1.4105v-1.4105Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#ee792f"
      d="M3.776375 11.066475H2.365845v1.4105h1.41053v-1.4105Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#000000"
      d="M4.481575 12.477h-1.410525v1.4105h1.410525v-1.4105Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#eb5829"
      d="M5.186875 12.477h-1.4105v1.4105h1.4105v-1.4105Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#ee792f"
      d="M8.007925 11.066475h-1.410525v1.4105h1.410525v-1.4105Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#ee792f"
      d="M2.36584 11.066475H0.9553225v1.4105h1.4105175v-1.4105Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#000000"
      d="M7.302475 12.477h-1.4105v1.4105h1.4105v-1.4105Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#eb5829"
      d="M8.007925 12.477h-1.410525v1.4105h1.410525v-1.4105Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#000000"
      d="M7.302475 13.887625h-1.4105v1.410525h1.4105v-1.410525Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#eb5829"
      d="M2.36584 12.477H0.9553225v1.4105h1.4105175v-1.4105Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#ea3326"
      d="M8.007925 13.887625h-1.410525v1.410525h1.410525v-1.410525Z"
      stroke-width="0.25"
    ></path>
    <path
      fill="#ea3326"
      d="M2.36584 13.887625H0.9553225v1.410525h1.4105175v-1.410525Z"
      stroke-width="0.25"
    ></path>
  </svg>,

  // Llama SVG
  <svg
    key="llama"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="#2c92f2"
    stroke="#2c92f2"
  >
    <g id="SVGRepo_iconCarrier">
      <path
        d="M16.0235,4.50341 C17.8529,4.3766 19.267,5.44519 20.2076,6.67737 C21.156,7.91976 21.8094,9.54336 22.1673,11.1394 C22.5251,12.7347 22.6208,14.4504 22.3239,15.9123 C22.0388,17.3161 21.2785,18.9223 19.5568,19.437 C17.9375,19.9211 16.5179,19.2167 15.5052,18.3648 C14.4894,17.5103 13.6292,16.3122 12.953,15.1885 C12.6252,14.6438 12.3272,14.0938 12.0637,13.573 C11.8001,14.0938 11.5021,14.6438 11.1743,15.1885 C10.4981,16.3122 9.63792,17.5103 8.62209,18.3648 C7.60941,19.2167 6.18982,19.9211 4.57048,19.437 C2.84884,18.9223 2.08848,17.3161 1.80341,15.9123 C1.50655,14.4504 1.60217,12.7347 1.95995,11.1394 C2.31789,9.54336 2.97134,7.91976 3.91972,6.67737 C4.86029,5.44519 6.27437,4.3766 8.10383,4.50341 C9.81996636,4.62237364 11.0674829,5.78648603 11.8446591,6.77187041 L12.0637,7.0609 L12.0637,7.0609 L12.2827156,6.77187041 C13.059814,5.78648603 14.3073182,4.62237364 16.0235,4.50341 Z M7.89637,7.49623 C7.47584,7.46708 6.92691,7.6821 6.30436,8.49766 C5.68961,9.30301 5.17981,10.4913 4.88724,11.7959 C4.59453,13.1011 4.5524,14.3747 4.74341,15.3153 C4.90819312,16.126825 5.17222414,16.4173547 5.33536471,16.5186918 L5.40276778,16.5532373 L5.40276778,16.5532373 L5.42973,16.5627 C5.6624,16.6322 6.04382,16.6134 6.69089,16.0691 C7.33482,15.5274 7.99318,14.6564 8.60392,13.6416 C8.87629333,13.1890333 9.12860444,12.7252222 9.35564593,12.2790926 L9.61563301,11.7540754 L9.61563301,11.7540754 L9.8493616,11.25714 L9.8493616,11.25714 L10.0548321,10.7993939 L10.0548321,10.7993939 L10.2300447,10.3919447 L10.2300447,10.3919447 L10.373,10.0459 L10.373,10.0459 C10.2165,9.73315 9.99218,9.32834 9.71032,8.92724 C9.06612,8.01052 8.42073,7.53258 7.89637,7.49623 Z M16.2309,7.49623 C15.7066,7.53258 15.0612,8.01052 14.417,8.92724 C14.1351,9.32834 13.9108,9.73315 13.7543,10.0459 L13.9809584,10.588688 L13.9809584,10.588688 L14.1715556,11.0226741 C14.2058156,11.0990422 14.2412947,11.1772747 14.2779512,11.25714 L14.511686,11.7540754 L14.511686,11.7540754 L14.7716778,12.2790926 C14.9987222,12.7252222 15.2510333,13.1890333 15.5234,13.6416 C16.1341,14.6564 16.7925,15.5274 17.4364,16.0691 C18.0372786,16.5745214 18.4090587,16.6268332 18.6454171,16.576082 L18.6976,16.5627 C18.8279,16.5237 19.1811,16.3141 19.3839,15.3153 C19.5749,14.3747 19.5328,13.1011 19.2401,11.7959 C18.9475,10.4913 18.4377,9.30301 17.8229,8.49766 C17.2004,7.6821 16.6515,7.46708 16.2309,7.49623 Z"
        fill="#09244B"
      ></path>
    </g>
  </svg>,
  // Perplexity SVG
  <svg
    key="perplexity"
    xmlns="http://www.w3.org/2000/svg"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
    image-rendering="optimizeQuality"
    fill-rule="evenodd"
    clip-rule="evenodd"
    viewBox="0 0 512 509.64"
  >
    <path
      fill="#1F1F1F"
      d="M115.613 0h280.774C459.974 0 512 52.025 512 115.612v278.415c0 63.587-52.026 115.613-115.613 115.613H115.613C52.026 509.64 0 457.614 0 394.027V115.612C0 52.025 52.026 0 115.613 0z"
    />
    <path
      fill="#fff"
      fill-rule="nonzero"
      d="M348.851 128.063l-68.946 58.302h68.946v-58.302zm-83.908 48.709l100.931-85.349v94.942h32.244v143.421h-38.731v90.004l-94.442-86.662v83.946h-17.023v-83.906l-96.596 86.246v-89.628h-37.445V186.365h38.732V90.768l95.309 84.958v-83.16h17.023l-.002 84.206zm-29.209 26.616c-34.955.02-69.893 0-104.83 0v109.375h20.415v-27.121l84.415-82.254zm41.445 0l82.208 82.324v27.051h21.708V203.388c-34.617 0-69.274.02-103.916 0zm-42.874-17.023l-64.669-57.646v57.646h64.669zm13.617 124.076v-95.2l-79.573 77.516v88.731l79.573-71.047zm17.252-95.022v94.863l77.19 70.83c0-29.485-.012-58.943-.012-88.425l-77.178-77.268z"
    />
  </svg>,

  <svg
    key="deepseek"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="100%"
    viewBox="0 0 200 200"
    enable-background="new 0 0 200 200"
  >
    <path
      fill="#000000"
      opacity="1.000000"
      stroke="none"
      d="
M126.000000,201.000000 
C84.025948,201.000000 42.551903,201.000000 1.038926,201.000000 
C1.038926,134.400986 1.038926,67.801956 1.038926,1.101457 
C67.557205,1.101457 134.114609,1.101457 200.836014,1.101457 
C200.836014,67.666336 200.836014,134.333130 200.836014,201.000000 
C176.135574,201.000000 151.317780,201.000000 126.000000,201.000000 
M112.933189,64.384239 
C112.573051,64.318779 112.212921,64.253326 111.462433,64.085091 
C111.462433,64.085091 111.066368,64.007172 110.913040,63.481060 
C110.609207,63.299454 110.305382,63.117847 109.996918,62.996307 
C109.996918,62.996307 110.054047,62.977222 109.822861,62.340187 
C108.879051,61.885445 107.935249,61.430706 106.980667,61.015022 
C106.980667,61.015022 107.021088,61.012154 106.909027,60.481911 
C106.607048,60.309746 106.305069,60.137581 105.992958,60.006260 
C105.992958,60.006260 106.031540,59.989479 105.975014,59.199574 
C104.175270,55.728035 105.059158,52.802876 107.455994,49.895901 
C108.191086,49.004353 107.930077,47.291504 107.683182,45.227501 
C104.451912,45.491192 101.220634,45.754879 97.530090,46.069881 
C97.530090,46.069881 97.068024,46.077854 96.921539,45.596710 
C96.608223,45.727928 96.294907,45.859146 96.002800,46.003716 
C96.002800,46.003716 95.997925,45.979088 95.207001,45.972771 
C89.461609,47.321320 83.716209,48.669865 77.985916,50.017284 
C77.985916,50.017284 77.990883,50.009136 77.880737,49.526276 
C77.593399,49.691574 77.306068,49.856873 76.500671,50.084690 
C76.328110,50.062870 76.155548,50.041046 75.883347,49.531338 
C75.587822,49.690472 75.292297,49.849606 74.094017,50.064125 
C71.083923,50.045731 68.073837,50.027332 64.688431,49.314278 
C60.796928,50.188549 56.905426,51.062820 52.258453,52.028381 
C44.091011,54.161694 37.989536,59.529213 32.939800,65.753067 
C28.930716,70.694328 25.210232,76.229057 25.002430,83.916969 
C24.614082,86.286255 24.225733,88.655533 23.180834,91.431343 
C22.788401,93.152771 21.941143,94.913498 22.085903,96.588501 
C22.588911,102.408775 23.436069,108.199310 24.236300,114.738274 
C28.447083,129.309006 37.123684,140.729630 49.659874,150.172836 
C56.442543,153.469055 63.102047,157.056610 70.038513,159.989044 
C79.058517,163.802292 88.660889,161.899628 98.038010,161.906174 
C99.072159,161.906891 100.107155,160.700882 101.905418,160.005096 
C104.225655,159.287491 106.545891,158.569885 109.518990,158.093109 
C114.800690,155.730621 120.082390,153.368134 125.421814,150.979828 
C130.643509,151.610397 136.413605,152.652954 142.210510,152.833313 
C144.460251,152.903336 146.770599,151.024887 149.001541,150.004562 
C149.001541,150.004562 149.028503,150.057739 149.777954,149.993042 
C152.568649,148.858139 152.905640,147.119934 150.684601,144.235809 
C148.503647,143.480911 146.322678,142.726013 143.934860,141.428543 
C143.593964,141.353714 143.253082,141.278900 142.521103,141.100937 
C142.521103,141.100937 142.122620,141.031769 141.878052,140.376862 
C140.600037,139.490067 139.322021,138.603287 137.892822,137.611588 
C147.251678,128.264969 154.467712,118.031418 157.163422,105.321274 
C158.011261,101.323799 162.066589,97.605827 158.984390,92.149719 
C157.839661,86.486839 160.195648,83.999702 165.843094,82.640205 
C170.145157,81.604584 173.954742,78.523155 178.611526,75.967125 
C184.234772,70.625885 185.472244,63.415852 186.690781,56.300533 
C186.895584,55.104584 185.601624,53.125454 184.441940,52.397583 
C183.593506,51.865055 181.597260,52.433556 180.520340,53.136189 
C177.839111,54.885525 175.390793,56.991814 171.984192,59.000271 
C166.702652,60.084682 161.421112,61.169090 156.742035,62.129803 
C153.870178,59.752663 150.324570,56.994480 146.991013,54.000202 
C144.518112,51.778965 142.308640,49.262589 140.004700,46.855770 
C138.486649,45.269913 137.009216,43.645149 135.513580,42.037811 
C134.361465,44.015308 132.272400,45.964581 132.211823,47.974968 
C131.862579,59.567093 130.807098,71.460205 142.537247,79.344345 
C143.712921,80.134537 142.662384,84.236946 142.645035,86.802162 
C140.759918,86.717339 138.488831,87.271774 137.069809,86.414993 
C134.089081,84.615250 131.469421,82.170166 128.858063,79.816330 
C124.200157,75.617714 119.658264,71.290375 114.918907,66.484581 
C114.613831,66.298767 114.308762,66.112961 114.001366,65.996742 
C114.001366,65.996742 114.070992,65.996719 113.932411,65.464272 
C113.627747,65.282295 113.323082,65.100319 113.020767,64.984962 
C113.020767,64.984962 113.085861,64.970619 112.933189,64.384239 
z"
    />
    <path
      fill="#506BFA"
      opacity="1.000000"
      stroke="none"
      d="
M108.866127,157.852280 
C106.545891,158.569885 104.225655,159.287491 101.045876,160.010742 
C81.871559,161.368393 64.415329,159.080566 48.855282,147.681274 
C38.504185,138.039032 30.169720,127.427757 25.990219,113.569122 
C25.277426,105.766891 24.557404,98.395851 23.837383,91.024818 
C24.225733,88.655533 24.614082,86.286255 25.264256,83.310394 
C26.239824,81.814415 27.233879,81.033058 27.624687,80.019165 
C32.425831,67.563324 41.003391,58.732395 53.480091,53.122322 
C57.610504,52.034111 61.337124,51.021523 65.063744,50.008934 
C68.073837,50.027332 71.083923,50.045731 74.791901,50.054337 
C75.489784,50.044544 75.982979,50.019218 75.982979,50.019218 
C76.155548,50.041046 76.328110,50.062870 77.003098,50.066475 
C77.505524,50.048256 77.990883,50.009136 77.990883,50.009136 
C77.990883,50.009136 77.985916,50.017284 78.087341,50.222404 
C78.375122,50.677818 78.598358,50.889187 79.128777,51.236118 
C80.569542,51.325611 81.739990,51.240604 83.316635,51.132057 
C87.814537,49.398708 91.906235,47.688900 95.997925,45.979088 
C95.997925,45.979088 96.002800,46.003716 96.261902,46.042419 
C96.703346,46.080036 96.885689,46.078945 97.068024,46.077854 
C97.068024,46.077854 97.530090,46.069881 98.057869,46.232891 
C101.352661,46.293644 104.119667,46.191387 106.815323,46.420753 
C105.718430,48.227772 104.610764,49.653534 103.683380,51.188236 
C101.289467,55.149834 101.980545,57.626030 106.031540,59.989479 
C106.031540,59.989479 105.992958,60.006260 106.118996,60.203548 
C106.451622,60.670742 106.710304,60.874516 107.021088,61.012154 
C107.021088,61.012154 106.980667,61.015022 107.102058,61.308285 
C108.166985,62.060104 109.110512,62.518661 110.054047,62.977219 
C110.054047,62.977222 109.996918,62.996307 110.133949,63.184250 
C110.536110,63.583851 110.801239,63.795509 111.066368,64.007172 
C111.066368,64.007172 111.462433,64.085091 111.843109,64.299194 
C112.479958,64.724548 112.767311,64.876984 113.085861,64.970619 
C113.085861,64.970619 113.020767,64.984962 113.149643,65.172211 
C113.542671,65.571877 113.806831,65.784302 114.070992,65.996719 
C114.070992,65.996719 114.001366,65.996742 114.135040,66.184158 
C114.535095,66.586670 114.801476,66.801765 115.067856,67.016869 
C119.658264,71.290375 124.200157,75.617714 128.858063,79.816330 
C131.469421,82.170166 134.089081,84.615250 137.069809,86.414993 
C138.488831,87.271774 140.759918,86.717339 142.645035,86.802155 
C142.662384,84.236946 143.712921,80.134537 142.537247,79.344345 
C130.807098,71.460205 131.862579,59.567093 132.211823,47.974968 
C132.272400,45.964581 134.361465,44.015308 135.513580,42.037811 
C137.009216,43.645149 138.486649,45.269913 140.004700,46.855770 
C142.308640,49.262589 144.518112,51.778965 146.991013,54.000202 
C150.324570,56.994480 153.870178,59.752663 156.742035,62.129803 
C161.421112,61.169090 166.702652,60.084682 172.822983,58.993263 
C176.821533,57.916653 179.981308,56.847054 184.158478,55.433052 
C183.705643,58.404003 183.650299,60.835770 182.930954,63.052013 
C181.471970,67.547035 179.653641,71.925423 177.983429,76.351883 
C173.954742,78.523155 170.145157,81.604584 165.843094,82.640205 
C160.195648,83.999702 157.839661,86.486839 158.714294,92.890930 
C154.913742,108.531723 149.497025,122.412621 138.648651,133.806580 
C134.505432,138.158157 135.754272,140.196396 142.122620,141.031769 
C142.122620,141.031769 142.521103,141.100937 142.900085,141.314667 
C143.535782,141.736038 143.823349,141.883606 144.141724,141.971100 
C146.322678,142.726013 148.503647,143.480911 150.824326,144.895172 
C150.318863,147.055588 149.673676,148.556656 149.028503,150.057739 
C149.028503,150.057739 149.001541,150.004562 148.555756,150.002609 
C144.136337,150.012024 140.162689,150.024170 136.189041,150.034622 
C129.345139,150.052612 123.340858,148.296204 118.377388,143.091675 
C114.574295,139.103851 110.118027,135.738953 105.706299,132.004852 
C105.290375,131.619934 105.120422,131.327194 104.942032,130.665283 
C101.412369,124.719452 98.220879,118.898964 94.309975,113.610474 
C80.914848,95.496971 64.271599,83.089432 40.348145,83.939598 
C33.350876,84.188271 30.958420,86.617737 32.309189,93.547432 
C33.481350,99.560806 35.022915,105.531067 36.886211,111.365494 
C37.556812,113.465302 39.640678,115.113762 41.049194,116.980637 
C41.018803,116.993073 41.045399,116.933029 41.021996,117.316498 
C42.019508,119.463173 43.040428,121.226364 44.030167,122.997101 
C43.998985,123.004631 43.996723,122.940521 44.124672,123.161461 
C44.519337,123.588928 44.786053,123.795456 45.024158,124.004135 
C44.995548,124.006294 45.014988,123.952309 45.056335,124.249031 
C45.420837,125.035454 45.743988,125.525154 46.030525,126.014511 
C45.993919,126.014183 45.994301,125.940956 46.128208,126.158295 
C46.530357,126.580688 46.798599,126.785759 47.036297,126.990891 
C47.005753,126.990952 47.034115,126.936852 47.060562,127.240990 
C47.399330,128.052750 47.711647,128.560364 48.276867,129.058105 
C48.697292,129.028076 48.864819,129.007935 49.013332,128.995239 
C48.994320,129.002716 49.010666,128.965256 49.015434,129.304077 
C49.693989,130.425262 50.367775,131.207626 51.017124,131.998260 
C50.992691,132.006531 51.003510,131.956085 51.127571,132.174576 
C51.516079,132.593658 51.780529,132.794250 52.018776,133.001282 
C51.992569,133.007706 52.004925,132.955170 52.128941,133.173660 
C52.517151,133.593109 52.781345,133.794067 53.019035,134.001266 
C52.992531,134.007507 53.004990,133.954483 53.128342,134.173523 
C53.514858,134.595352 53.778015,134.798172 54.014359,135.005890 
C53.987545,135.010803 53.999012,134.957504 54.127552,135.176361 
C54.521080,135.601700 54.786072,135.808182 55.247932,136.049377 
C55.444801,136.084122 55.831356,136.186264 56.019238,136.346832 
C56.467548,136.715714 56.757904,136.866302 57.049500,136.973511 
C57.020802,136.987839 57.030655,136.924454 57.156334,137.144196 
C57.545414,137.570694 57.808819,137.777481 58.040276,137.988129 
C58.008327,137.992004 58.016972,137.928207 58.145012,138.151566 
C58.540348,138.586349 58.807644,138.797775 59.264503,139.044693 
C59.454063,139.080185 59.827618,139.176270 60.013676,139.338013 
C60.454762,139.714142 60.742077,139.868362 61.036018,139.980606 
C61.010353,139.998795 61.032845,139.940048 61.146442,140.163452 
C61.521412,140.589890 61.782784,140.792938 62.018623,141.000443 
C61.993095,141.004913 62.012505,140.956863 62.117184,141.289886 
C67.388367,146.347366 73.178185,147.253601 77.091576,143.718689 
C77.335556,143.217667 77.588570,143.056595 78.227112,142.947937 
C81.792549,140.941559 79.890587,138.594604 78.854530,136.550308 
C76.625137,132.151443 76.802490,131.731491 82.293747,131.069702 
C82.495201,131.104996 82.889488,131.213898 83.062965,131.386185 
C83.485962,131.778671 83.772171,131.929001 84.284409,132.051300 
C84.473763,132.093170 84.845581,132.203522 85.025894,132.368256 
C85.462029,132.742401 85.749870,132.888840 86.038864,132.977753 
C86.008003,132.983200 86.034927,132.926590 86.140274,133.246216 
C87.191757,134.053223 88.137894,134.540619 89.395042,135.176666 
C92.415886,137.287521 95.125717,139.249710 98.018860,141.375931 
C98.460548,141.750778 98.751816,141.895248 99.044937,141.981720 
C99.013924,141.990082 99.015762,141.925858 99.144516,142.149231 
C99.543541,142.581192 99.813812,142.789764 100.042709,142.999146 
C100.001335,142.999954 99.999809,142.917206 100.138275,143.137665 
C100.543022,143.578110 100.809311,143.798096 101.255783,144.047943 
C101.435959,144.077805 101.782043,144.194611 101.987152,144.375397 
C102.518509,144.713150 102.844757,144.870102 103.415985,145.125275 
C104.055717,145.557770 104.450485,145.892044 105.033981,146.524658 
C109.538498,148.209518 113.854286,149.596024 118.973747,151.240707 
C115.261635,153.668869 112.063881,155.760574 108.866127,157.852280 
M117.984520,109.022324 
C117.984520,109.022324 117.996857,108.965248 118.070595,109.693359 
C119.413109,110.469315 120.755623,111.245270 122.541138,112.103989 
C122.541138,112.103989 122.965340,112.256149 123.647591,112.598404 
C130.656372,113.516624 132.623688,111.769890 130.844376,105.314529 
C129.535400,103.235893 128.226440,101.157265 126.800529,98.401917 
C124.262054,95.659737 122.128647,92.251724 119.058273,90.383842 
C116.554840,88.860840 112.755089,88.301178 109.844437,88.884010 
C105.282967,89.797401 105.124733,92.778786 108.788971,96.509079 
C108.678764,98.576004 108.568565,100.642937 108.458359,102.709869 
C110.501549,102.537659 112.544739,102.365448 114.246857,102.221985 
C115.069687,103.607552 116.067284,105.287422 117.013565,106.998657 
C117.013565,106.998657 117.021889,106.939079 117.101822,107.532639 
C117.415497,108.028252 117.729172,108.523857 117.984520,109.022324 
z"
    />
    <path
      fill="#6376D5"
      opacity="1.000000"
      stroke="none"
      d="
M105.952263,132.097015 
C110.118027,135.738953 114.574295,139.103851 118.377388,143.091675 
C123.340858,148.296204 129.345139,150.052612 136.189041,150.034622 
C140.162689,150.024170 144.136337,150.012024 148.581665,150.017334 
C146.770599,151.024887 144.460251,152.903336 142.210510,152.833313 
C136.413605,152.652954 130.643509,151.610397 125.421814,150.979828 
C120.082390,153.368134 114.800690,155.730621 109.192558,157.972687 
C112.063881,155.760574 115.261635,153.668869 118.973747,151.240707 
C113.854286,149.596024 109.538498,148.209518 105.450089,146.415405 
C109.983162,146.780869 114.288857,147.553925 119.134888,148.423996 
C114.275093,142.405029 110.113678,137.251022 105.952263,132.097015 
z"
    />
    <path
      fill="#6477D7"
      opacity="1.000000"
      stroke="none"
      d="
M142.000336,140.704315 
C135.754272,140.196396 134.505432,138.158157 138.648651,133.806580 
C149.497025,122.412621 154.913742,108.531723 158.641159,93.329666 
C162.066589,97.605827 158.011261,101.323799 157.163422,105.321274 
C154.467712,118.031418 147.251678,128.264969 137.892822,137.611588 
C139.322021,138.603287 140.600037,139.490067 142.000336,140.704315 
z"
    />
    <path
      fill="#5D6FD4"
      opacity="1.000000"
      stroke="none"
      d="
M49.044106,147.953262 
C64.415329,159.080566 81.871559,161.368393 100.664047,160.035461 
C100.107155,160.700882 99.072159,161.906891 98.038010,161.906174 
C88.660889,161.899628 79.058517,163.802292 70.038513,159.989044 
C63.102047,157.056610 56.442543,153.469055 49.345627,149.704636 
C49.035622,148.808716 49.039864,148.380981 49.044106,147.953262 
z"
    />
    <path
      fill="#667AD7"
      opacity="1.000000"
      stroke="none"
      d="
M53.076302,53.197945 
C41.003391,58.732395 32.425831,67.563324 27.624687,80.019165 
C27.233879,81.033058 26.239824,81.814415 25.234821,82.906937 
C25.210232,76.229057 28.930716,70.694328 32.939800,65.753067 
C37.989536,59.529213 44.091011,54.161694 52.647408,52.298294 
C53.049675,52.778118 53.062988,52.988033 53.076302,53.197945 
z"
    />
    <path
      fill="#6679D5"
      opacity="1.000000"
      stroke="none"
      d="
M48.855286,147.681274 
C49.039864,148.380981 49.035622,148.808716 49.027069,149.556793 
C37.123684,140.729630 28.447083,129.309006 24.499527,114.368980 
C25.169498,113.999893 25.576244,114.000107 25.982990,114.000313 
C30.169720,127.427757 38.504185,138.039032 48.855286,147.681274 
z"
    />
    <path
      fill="#6375D1"
      opacity="1.000000"
      stroke="none"
      d="
M178.297485,76.159508 
C179.653641,71.925423 181.471970,67.547035 182.930954,63.052013 
C183.650299,60.835770 183.705643,58.404003 184.158478,55.433052 
C179.981308,56.847054 176.821533,57.916653 173.255371,58.970520 
C175.390793,56.991814 177.839111,54.885525 180.520340,53.136189 
C181.597260,52.433556 183.593506,51.865055 184.441940,52.397583 
C185.601624,53.125454 186.895584,55.104584 186.690781,56.300533 
C185.472244,63.415852 184.234772,70.625885 178.297485,76.159508 
z"
    />
    <path
      fill="#6173D6"
      opacity="1.000000"
      stroke="none"
      d="
M25.990219,113.569122 
C25.576244,114.000107 25.169498,113.999893 24.457544,114.000420 
C23.436069,108.199310 22.588911,102.408775 22.085903,96.588501 
C21.941143,94.913498 22.788401,93.152771 23.509108,91.228081 
C24.557404,98.395851 25.277426,105.766891 25.990219,113.569122 
z"
    />
    <path
      fill="#5E73D6"
      opacity="1.000000"
      stroke="none"
      d="
M106.003281,59.594528 
C101.980545,57.626030 101.289467,55.149834 103.683380,51.188236 
C104.610764,49.653534 105.718430,48.227772 107.125198,46.384258 
C107.712692,45.995674 107.918945,45.975212 108.125206,45.954754 
C107.930077,47.291504 108.191086,49.004353 107.455994,49.895901 
C105.059158,52.802876 104.175270,55.728035 106.003281,59.594528 
z"
    />
    <path
      fill="#6478D1"
      opacity="1.000000"
      stroke="none"
      d="
M78.858452,51.061619 
C78.598358,50.889187 78.375122,50.677818 78.079788,50.222965 
C83.716209,48.669865 89.461609,47.321320 95.602463,45.975929 
C91.906235,47.688900 87.814537,49.398708 82.916733,51.101501 
C81.026566,51.083534 79.942505,51.072575 78.858452,51.061619 
z"
    />
    <path
      fill="#556AD0"
      opacity="1.000000"
      stroke="none"
      d="
M53.480091,53.122322 
C53.062988,52.988033 53.049675,52.778118 53.025146,52.252647 
C56.905426,51.062820 60.796928,50.188549 64.876083,49.661606 
C61.337124,51.021523 57.610504,52.034111 53.480091,53.122322 
z"
    />
    <path
      fill="#6478D1"
      opacity="1.000000"
      stroke="none"
      d="
M107.904190,45.591125 
C107.918945,45.975212 107.712692,45.995674 107.196556,46.052635 
C104.119667,46.191387 101.352661,46.293644 98.287506,46.207237 
C101.220634,45.754879 104.451912,45.491192 107.904190,45.591125 
z"
    />
    <path
      fill="#6376D5"
      opacity="1.000000"
      stroke="none"
      d="
M149.403229,150.025391 
C149.673676,148.556656 150.318863,147.055588 151.004333,145.197906 
C152.905640,147.119934 152.568649,148.858139 149.403229,150.025391 
z"
    />
    <path
      fill="#5E73D6"
      opacity="1.000000"
      stroke="none"
      d="
M109.938454,62.658703 
C109.110512,62.518661 108.166985,62.060104 107.107452,61.288757 
C107.935249,61.430706 108.879051,61.885445 109.938454,62.658703 
z"
    />
    <path
      fill="#6478D1"
      opacity="1.000000"
      stroke="none"
      d="
M96.994781,45.837280 
C96.885689,46.078945 96.703346,46.080036 96.251297,46.035744 
C96.294907,45.859146 96.608223,45.727928 96.994781,45.837280 
z"
    />
    <path
      fill="#6477D7"
      opacity="1.000000"
      stroke="none"
      d="
M144.038300,141.699829 
C143.823349,141.883606 143.535782,141.736038 143.095612,141.366241 
C143.253082,141.278900 143.593964,141.353714 144.038300,141.699829 
z"
    />
    <path
      fill="#556AD0"
      opacity="1.000000"
      stroke="none"
      d="
M75.933167,49.775276 
C75.982979,50.019218 75.489784,50.044544 75.243286,50.026642 
C75.292297,49.849606 75.587822,49.690472 75.933167,49.775276 
z"
    />
    <path
      fill="#556AD0"
      opacity="1.000000"
      stroke="none"
      d="
M77.935806,49.767708 
C77.990883,50.009136 77.505524,50.048256 77.262131,50.035213 
C77.306068,49.856873 77.593399,49.691574 77.935806,49.767708 
z"
    />
    <path
      fill="#5E73D6"
      opacity="1.000000"
      stroke="none"
      d="
M114.993378,66.750725 
C114.801476,66.801765 114.535095,66.586670 114.136200,66.149368 
C114.308762,66.112961 114.613831,66.298767 114.993378,66.750725 
z"
    />
    <path
      fill="#5E73D6"
      opacity="1.000000"
      stroke="none"
      d="
M114.001701,65.730499 
C113.806831,65.784302 113.542671,65.571877 113.148468,65.138901 
C113.323082,65.100319 113.627747,65.282295 114.001701,65.730499 
z"
    />
    <path
      fill="#5E73D6"
      opacity="1.000000"
      stroke="none"
      d="
M113.009521,64.677429 
C112.767311,64.876984 112.479958,64.724548 112.038284,64.350586 
C112.212921,64.253326 112.573051,64.318779 113.009521,64.677429 
z"
    />
    <path
      fill="#5E73D6"
      opacity="1.000000"
      stroke="none"
      d="
M110.989700,63.744118 
C110.801239,63.795509 110.536110,63.583851 110.136261,63.154213 
C110.305382,63.117847 110.609207,63.299454 110.989700,63.744118 
z"
    />
    <path
      fill="#5E73D6"
      opacity="1.000000"
      stroke="none"
      d="
M106.965057,60.747032 
C106.710304,60.874516 106.451622,60.670742 106.124062,60.183128 
C106.305069,60.137581 106.607048,60.309746 106.965057,60.747032 
z"
    />
    <path
      fill="#000000"
      opacity="1.000000"
      stroke="none"
      d="
M105.706299,132.004852 
C110.113678,137.251022 114.275093,142.405029 119.134888,148.423996 
C114.288857,147.553925 109.983162,146.780869 105.261360,146.117050 
C104.450485,145.892044 104.055717,145.557770 103.308685,144.814957 
C102.564949,144.335815 102.173500,144.265213 101.782043,144.194611 
C101.782043,144.194611 101.435959,144.077805 101.181526,143.777893 
C100.617996,143.291061 100.308907,143.104141 99.999809,142.917206 
C99.999809,142.917206 100.001335,142.999954 99.971214,142.730927 
C99.632652,142.283218 99.324211,142.104538 99.015762,141.925858 
C99.015762,141.925858 99.013924,141.990082 98.971413,141.684540 
C98.564453,141.323303 98.199997,141.267593 97.835548,141.211884 
C95.125717,139.249710 92.415886,137.287521 89.284470,134.852112 
C87.920227,133.894775 86.977577,133.410690 86.034927,132.926590 
C86.034927,132.926590 86.008003,132.983200 85.959915,132.690918 
C85.556419,132.333618 85.200996,132.268570 84.845581,132.203522 
C84.845581,132.203522 84.473763,132.093170 84.198074,131.771118 
C83.578094,131.370682 83.233795,131.292282 82.889488,131.213898 
C82.889488,131.213898 82.495201,131.104996 82.117126,130.709305 
C79.655930,129.751541 77.572792,129.189468 74.787666,128.437988 
C75.134071,131.311859 75.200371,133.263809 75.634727,135.130096 
C76.254036,137.791061 77.143219,140.389206 77.917130,143.014191 
C77.588570,143.056595 77.335556,143.217667 76.689316,143.735443 
C70.875900,145.834518 66.749519,141.957703 62.012505,140.956863 
C62.012505,140.956863 61.993095,141.004913 61.959656,140.737671 
C61.628422,140.293655 61.330631,140.116852 61.032845,139.940048 
C61.032845,139.940048 61.010353,139.998795 60.972126,139.678589 
C60.565140,139.297684 60.196381,139.236969 59.827618,139.176270 
C59.827618,139.176270 59.454063,139.080185 59.188522,138.781189 
C58.620979,138.297531 58.318977,138.112869 58.016972,137.928207 
C58.016972,137.928207 58.008327,137.992004 57.980343,137.719025 
C57.645123,137.272186 57.337891,137.098328 57.030655,136.924454 
C57.030655,136.924454 57.020802,136.987839 56.974747,136.676941 
C56.562912,136.306107 56.197132,136.246185 55.831356,136.186264 
C55.831356,136.186264 55.444801,136.084122 55.169518,135.791016 
C54.595825,135.317764 54.297417,135.137634 53.999012,134.957504 
C53.999012,134.957504 53.987545,135.010803 53.945133,134.745667 
C53.603477,134.305176 53.304234,134.129822 53.004990,133.954483 
C53.004990,133.954483 52.992531,134.007507 52.947010,133.742645 
C52.602634,133.303558 52.303780,133.129364 52.004929,132.955170 
C52.004925,132.955170 51.992569,133.007706 51.945274,132.743622 
C51.599823,132.305038 51.301666,132.130554 51.003510,131.956085 
C51.003510,131.956085 50.992691,132.006531 50.983376,131.670441 
C50.319592,130.544647 49.665131,129.754959 49.010666,128.965256 
C49.010666,128.965256 48.994320,129.002716 48.956543,128.745132 
C48.649555,128.290497 48.380341,128.093460 48.022957,127.648720 
C47.634567,127.246300 47.334343,127.091576 47.034115,126.936852 
C47.034115,126.936852 47.005753,126.990952 46.967133,126.722610 
C46.617111,126.283165 46.305706,126.112061 45.994301,125.940956 
C45.994301,125.940956 45.993919,126.014183 45.988503,125.698135 
C45.660385,124.905495 45.337685,124.428902 45.014984,123.952309 
C45.014988,123.952309 44.995548,124.006294 44.965080,123.731628 
C44.621986,123.284821 44.309357,123.112671 43.996723,122.940521 
C43.996723,122.940521 43.998985,123.004631 43.973984,122.643532 
C42.981121,120.499298 42.013260,118.716164 41.045395,116.933029 
C41.045399,116.933029 41.018803,116.993073 41.021774,116.600082 
C38.747269,107.643311 36.296734,99.117630 34.393219,90.471504 
C34.130894,89.279961 36.420750,86.390335 37.805759,86.188835 
C41.705116,85.621536 45.899612,85.359634 49.709789,86.196846 
C67.506508,90.107353 81.951584,99.148537 92.198601,114.612045 
C96.016220,120.373116 100.675163,125.576675 104.950470,131.034454 
C105.120422,131.327194 105.290375,131.619934 105.706299,132.004852 
z"
    />
    <path
      fill="#6477D7"
      opacity="1.000000"
      stroke="none"
      d="
M104.942032,130.665283 
C100.675163,125.576675 96.016220,120.373116 92.198601,114.612045 
C81.951584,99.148537 67.506508,90.107353 49.709789,86.196846 
C45.899612,85.359634 41.705116,85.621536 37.805759,86.188835 
C36.420750,86.390335 34.130894,89.279961 34.393219,90.471504 
C36.296734,99.117630 38.747269,107.643311 41.052166,116.587646 
C39.640678,115.113762 37.556812,113.465302 36.886211,111.365494 
C35.022915,105.531067 33.481350,99.560806 32.309189,93.547432 
C30.958420,86.617737 33.350876,84.188271 40.348145,83.939598 
C64.271599,83.089432 80.914848,95.496971 94.309975,113.610474 
C98.220879,118.898964 101.412369,124.719452 104.942032,130.665283 
z"
    />
    <path
      fill="#000000"
      opacity="1.000000"
      stroke="none"
      d="
M126.917473,99.078629 
C128.226440,101.157265 129.535400,103.235893 130.850098,105.966721 
C129.855209,110.778877 126.581177,111.756729 122.965340,112.256149 
C122.965340,112.256149 122.541138,112.103989 122.195335,111.747620 
C120.565308,110.582581 119.281082,109.773918 117.996857,108.965248 
C117.996857,108.965248 117.984520,109.022324 117.976974,108.705170 
C117.653587,107.905037 117.337738,107.422058 117.021889,106.939079 
C117.021889,106.939079 117.013565,106.998657 117.035950,106.539520 
C116.807449,96.033684 116.272774,95.280502 108.936523,94.513931 
C109.067245,93.176247 109.014313,91.597198 109.655624,91.229713 
C113.764954,88.875000 116.997597,91.238380 120.113426,93.622711 
C122.421532,95.388947 124.652267,97.256310 126.917473,99.078629 
z"
    />
    <path
      fill="#576ED4"
      opacity="1.000000"
      stroke="none"
      d="
M109.073898,94.832809 
C116.272774,95.280502 116.807449,96.033684 117.061615,106.523834 
C116.067284,105.287422 115.069687,103.607552 114.246857,102.221985 
C112.544739,102.365448 110.501549,102.537659 108.458359,102.709869 
C108.568565,100.642937 108.678764,98.576004 108.908676,95.959686 
C109.043556,95.217796 109.058723,95.025307 109.073898,94.832809 
z"
    />
    <path
      fill="#5C71D9"
      opacity="1.000000"
      stroke="none"
      d="
M108.936523,94.513931 
C109.058723,95.025307 109.043556,95.217796 109.008034,95.699036 
C105.124733,92.778786 105.282967,89.797401 109.844437,88.884010 
C112.755089,88.301178 116.554840,88.860840 119.058273,90.383842 
C122.128647,92.251724 124.262054,95.659737 126.859001,98.740273 
C124.652267,97.256310 122.421532,95.388947 120.113426,93.622711 
C116.997597,91.238380 113.764954,88.875000 109.655624,91.229713 
C109.014313,91.597198 109.067245,93.176247 108.936523,94.513931 
z"
    />
    <path
      fill="#5C6FD4"
      opacity="1.000000"
      stroke="none"
      d="
M78.227112,142.947937 
C77.143219,140.389206 76.254036,137.791061 75.634727,135.130096 
C75.200371,133.263809 75.134071,131.311859 74.787666,128.437988 
C77.572792,129.189468 79.655930,129.751541 81.915672,130.674011 
C76.802490,131.731491 76.625137,132.151443 78.854530,136.550308 
C79.890587,138.594604 81.792549,140.941559 78.227112,142.947937 
z"
    />
    <path
      fill="#5C6FD4"
      opacity="1.000000"
      stroke="none"
      d="
M62.117184,141.289886 
C66.749519,141.957703 70.875900,145.834518 76.622803,143.956726 
C73.178185,147.253601 67.388367,146.347366 62.117184,141.289886 
z"
    />
    <path
      fill="#6477D9"
      opacity="1.000000"
      stroke="none"
      d="
M123.306465,112.427277 
C126.581177,111.756729 129.855209,110.778877 131.012878,106.269180 
C132.623688,111.769890 130.656372,113.516624 123.306465,112.427277 
z"
    />
    <path
      fill="#6477D7"
      opacity="1.000000"
      stroke="none"
      d="
M41.021996,117.316498 
C42.013260,118.716164 42.981121,120.499298 44.005165,122.636002 
C43.040428,121.226364 42.019508,119.463173 41.021996,117.316498 
z"
    />
    <path
      fill="#6477D9"
      opacity="1.000000"
      stroke="none"
      d="
M118.033722,109.329300 
C119.281082,109.773918 120.565308,110.582581 121.973831,111.706238 
C120.755623,111.245270 119.413109,110.469315 118.033722,109.329300 
z"
    />
    <path
      fill="#5C6FD4"
      opacity="1.000000"
      stroke="none"
      d="
M86.140274,133.246216 
C86.977577,133.410690 87.920227,133.894775 88.973457,134.703430 
C88.137894,134.540619 87.191757,134.053223 86.140274,133.246216 
z"
    />
    <path
      fill="#5C6FD4"
      opacity="1.000000"
      stroke="none"
      d="
M49.015434,129.304077 
C49.665131,129.754959 50.319592,130.544647 51.007805,131.662170 
C50.367775,131.207626 49.693989,130.425262 49.015434,129.304077 
z"
    />
    <path
      fill="#556AD0"
      opacity="1.000000"
      stroke="none"
      d="
M79.128777,51.236118 
C79.942505,51.072575 81.026566,51.083534 82.510529,51.125046 
C81.739990,51.240604 80.569542,51.325611 79.128777,51.236118 
z"
    />
    <path
      fill="#6477D7"
      opacity="1.000000"
      stroke="none"
      d="
M45.056335,124.249031 
C45.337685,124.428902 45.660385,124.905495 46.025108,125.698471 
C45.743988,125.525154 45.420837,125.035454 45.056335,124.249031 
z"
    />
    <path
      fill="#6477D7"
      opacity="1.000000"
      stroke="none"
      d="
M47.060562,127.240990 
C47.334343,127.091576 47.634567,127.246300 47.997932,127.941017 
C48.048698,128.676682 48.036331,128.872345 48.023964,129.067993 
C47.711647,128.560364 47.399330,128.052750 47.060562,127.240990 
z"
    />
    <path
      fill="#6477D9"
      opacity="1.000000"
      stroke="none"
      d="
M117.061859,107.235855 
C117.337738,107.422058 117.653587,107.905037 118.006134,108.703751 
C117.729172,108.523857 117.415497,108.028252 117.061859,107.235855 
z"
    />
    <path
      fill="#6376D5"
      opacity="1.000000"
      stroke="none"
      d="
M100.138275,143.137665 
C100.308907,143.104141 100.617996,143.291061 101.001350,143.748047 
C100.809311,143.798096 100.543022,143.578110 100.138275,143.137665 
z"
    />
    <path
      fill="#5C6FD4"
      opacity="1.000000"
      stroke="none"
      d="
M54.127552,135.176361 
C54.297417,135.137634 54.595825,135.317764 54.972649,135.756271 
C54.786072,135.808182 54.521080,135.601700 54.127552,135.176361 
z"
    />
    <path
      fill="#5C6FD4"
      opacity="1.000000"
      stroke="none"
      d="
M56.019238,136.346832 
C56.197132,136.246185 56.562912,136.306107 57.003441,136.662598 
C56.757904,136.866302 56.467548,136.715714 56.019238,136.346832 
z"
    />
    <path
      fill="#5C6FD4"
      opacity="1.000000"
      stroke="none"
      d="
M57.156334,137.144196 
C57.337891,137.098328 57.645123,137.272186 58.012291,137.715149 
C57.808819,137.777481 57.545414,137.570694 57.156334,137.144196 
z"
    />
    <path
      fill="#5C6FD4"
      opacity="1.000000"
      stroke="none"
      d="
M58.145012,138.151566 
C58.318977,138.112869 58.620979,138.297531 58.998962,138.745697 
C58.807644,138.797775 58.540348,138.586349 58.145012,138.151566 
z"
    />
    <path
      fill="#6376D5"
      opacity="1.000000"
      stroke="none"
      d="
M101.987152,144.375397 
C102.173500,144.265213 102.564949,144.335815 103.063705,144.716736 
C102.844757,144.870102 102.518509,144.713150 101.987152,144.375397 
z"
    />
    <path
      fill="#5C6FD4"
      opacity="1.000000"
      stroke="none"
      d="
M60.013676,139.338013 
C60.196381,139.236969 60.565140,139.297684 60.997787,139.660400 
C60.742077,139.868362 60.454762,139.714142 60.013676,139.338013 
z"
    />
    <path
      fill="#5C6FD4"
      opacity="1.000000"
      stroke="none"
      d="
M61.146439,140.163452 
C61.330631,140.116852 61.628422,140.293655 61.985184,140.733215 
C61.782784,140.792938 61.521412,140.589890 61.146439,140.163452 
z"
    />
    <path
      fill="#6376D5"
      opacity="1.000000"
      stroke="none"
      d="
M98.018860,141.375931 
C98.199997,141.267593 98.564453,141.323303 99.002426,141.676193 
C98.751816,141.895248 98.460548,141.750778 98.018860,141.375931 
z"
    />
    <path
      fill="#6376D5"
      opacity="1.000000"
      stroke="none"
      d="
M99.144516,142.149231 
C99.324211,142.104538 99.632652,142.283218 100.012589,142.730133 
C99.813812,142.789764 99.543541,142.581192 99.144516,142.149231 
z"
    />
    <path
      fill="#5C6FD4"
      opacity="1.000000"
      stroke="none"
      d="
M53.128342,134.173523 
C53.304234,134.129822 53.603477,134.305176 53.971947,134.740753 
C53.778015,134.798172 53.514858,134.595352 53.128342,134.173523 
z"
    />
    <path
      fill="#5C6FD4"
      opacity="1.000000"
      stroke="none"
      d="
M52.128944,133.173660 
C52.303780,133.129364 52.602634,133.303558 52.973515,133.736389 
C52.781345,133.794067 52.517151,133.593109 52.128944,133.173660 
z"
    />
    <path
      fill="#5C6FD4"
      opacity="1.000000"
      stroke="none"
      d="
M85.025894,132.368256 
C85.200996,132.268570 85.556419,132.333618 85.990784,132.685486 
C85.749870,132.888840 85.462029,132.742401 85.025894,132.368256 
z"
    />
    <path
      fill="#5C6FD4"
      opacity="1.000000"
      stroke="none"
      d="
M51.127571,132.174576 
C51.301666,132.130554 51.599823,132.305038 51.971481,132.737183 
C51.780529,132.794250 51.516079,132.593658 51.127571,132.174576 
z"
    />
    <path
      fill="#5C6FD4"
      opacity="1.000000"
      stroke="none"
      d="
M83.062965,131.386185 
C83.233795,131.292282 83.578094,131.370682 84.008728,131.729263 
C83.772171,131.929001 83.485962,131.778671 83.062965,131.386185 
z"
    />
    <path
      fill="#5C6FD4"
      opacity="1.000000"
      stroke="none"
      d="
M48.276867,129.058105 
C48.036331,128.872345 48.048698,128.676682 48.086098,128.188705 
C48.380341,128.093460 48.649555,128.290497 48.975555,128.737671 
C48.864819,129.007935 48.697292,129.028076 48.276867,129.058105 
z"
    />
    <path
      fill="#6477D7"
      opacity="1.000000"
      stroke="none"
      d="
M46.128208,126.158295 
C46.305706,126.112061 46.617111,126.283165 46.997681,126.722549 
C46.798599,126.785759 46.530357,126.580688 46.128208,126.158295 
z"
    />
    <path
      fill="#6477D7"
      opacity="1.000000"
      stroke="none"
      d="
M44.124672,123.161461 
C44.309357,123.112671 44.621986,123.284821 44.993690,123.729477 
C44.786053,123.795456 44.519337,123.588928 44.124672,123.161461 
z"
    />
  </svg>,

  <svg
    key="cohere"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="100%"
    viewBox="0 0 280 280"
    enable-background="new 0 0 280 280"
  >
    <path
      fill="#FFFFFF"
      opacity="1.000000"
      stroke="none"
      d="
M181.000000,281.000000 
	C120.666672,281.000000 60.833347,281.000000 1.000016,281.000000 
	C1.000011,187.666687 1.000011,94.333366 1.000005,1.000041 
	C94.333305,1.000027 187.666611,1.000027 280.999939,1.000014 
	C280.999939,94.333290 280.999939,187.666580 280.999969,280.999939 
	C247.833328,281.000000 214.666672,281.000000 181.000000,281.000000 
M98.302078,155.315598 
	C110.657745,157.899963 122.809647,157.087509 134.548111,152.501816 
	C147.997330,147.247803 161.439423,141.935989 174.637939,136.092178 
	C185.394302,131.329651 196.252869,126.500771 206.228256,120.343811 
	C219.901535,111.904465 224.586441,96.813019 219.810745,81.546776 
	C215.413635,67.490730 202.190353,58.009369 186.913635,58.002174 
	C160.105530,57.989552 133.297440,57.993469 106.489349,58.009186 
	C104.494614,58.010353 102.470329,57.969418 100.509781,58.271980 
	C77.109184,61.883324 59.036243,81.363632 58.162186,103.839180 
	C57.148754,129.898560 72.150009,149.488495 98.302078,155.315598 
M203.938507,151.447205 
	C194.040405,146.001740 183.579651,145.148224 173.129105,148.963898 
	C162.693878,152.773972 152.418564,157.128067 142.380020,161.890518 
	C131.111099,167.236649 123.397415,182.180878 125.167274,193.736191 
	C127.521927,209.109497 137.480621,221.090195 151.236618,222.773010 
	C162.557114,224.157898 174.111862,223.880951 185.562531,223.874466 
	C196.132843,223.868484 205.394135,219.921295 212.899048,212.472992 
	C230.010406,195.490692 227.513947,164.979446 203.938507,151.447205 
M89.197166,163.087936 
	C85.114037,163.627884 80.809647,163.520020 76.987953,164.825378 
	C63.852402,169.311966 57.657738,180.223679 58.134010,196.940353 
	C58.584370,212.747299 74.053490,225.823410 89.734329,223.652191 
	C103.924973,221.687317 114.738747,210.308594 115.002914,197.063461 
	C115.393227,177.493500 107.156975,166.295639 89.197166,163.087936 
z"
    />
    <path
      fill="#365247"
      opacity="1.000000"
      stroke="none"
      d="
M97.882866,155.238998 
	C72.150009,149.488495 57.148754,129.898560 58.162186,103.839180 
	C59.036243,81.363632 77.109184,61.883324 100.509781,58.271980 
	C102.470329,57.969418 104.494614,58.010353 106.489349,58.009186 
	C133.297440,57.993469 160.105530,57.989552 186.913635,58.002174 
	C202.190353,58.009369 215.413635,67.490730 219.810745,81.546776 
	C224.586441,96.813019 219.901535,111.904465 206.228256,120.343811 
	C196.252869,126.500771 185.394302,131.329651 174.637939,136.092178 
	C161.439423,141.935989 147.997330,147.247803 134.548111,152.501816 
	C122.809647,157.087509 110.657745,157.899963 97.882866,155.238998 
z"
    />
    <path
      fill="#D9A7E5"
      opacity="1.000000"
      stroke="none"
      d="
M204.264893,151.623413 
	C227.513947,164.979446 230.010406,195.490692 212.899048,212.472992 
	C205.394135,219.921295 196.132843,223.868484 185.562531,223.874466 
	C174.111862,223.880951 162.557114,224.157898 151.236618,222.773010 
	C137.480621,221.090195 127.521927,209.109497 125.167274,193.736191 
	C123.397415,182.180878 131.111099,167.236649 142.380020,161.890518 
	C152.418564,157.128067 162.693878,152.773972 173.129105,148.963898 
	C183.579651,145.148224 194.040405,146.001740 204.264893,151.623413 
z"
    />
    <path
      fill="#FF785B"
      opacity="1.000000"
      stroke="none"
      d="
M89.634903,163.128326 
	C107.156975,166.295639 115.393227,177.493500 115.002914,197.063461 
	C114.738747,210.308594 103.924973,221.687317 89.734329,223.652191 
	C74.053490,225.823410 58.584370,212.747299 58.134010,196.940353 
	C57.657738,180.223679 63.852402,169.311966 76.987953,164.825378 
	C80.809647,163.520020 85.114037,163.627884 89.634903,163.128326 
z"
    />
  </svg>,

<svg key="other" fill="#000000" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
	 viewBox="0 0 512 512">
<g>
	<g>
		<path d="M498.095,198.122c0-25.763-9.68-50.313-27.257-69.131c-13.197-14.129-29.915-24.039-48.274-28.848
			c0.253-2.749,0.397-5.521,0.397-8.313C422.962,41.194,381.768,0,331.133,0C300.099,0,272.631,15.49,256,39.129
			C239.369,15.49,211.901,0,180.867,0c-50.635,0-91.828,41.194-91.828,91.828c0,2.794,0.145,5.565,0.397,8.313
			c-18.359,4.808-35.075,14.719-48.274,28.848c-17.578,18.819-27.257,43.37-27.257,69.132c0,21.486,6.731,41.427,18.185,57.837
			c-11.804,16.895-18.185,37.001-18.185,57.919c0,46.95,32.11,86.538,75.522,97.967c-0.249,2.761-0.39,5.537-0.39,8.327
			c0,50.635,41.194,91.828,91.828,91.828c31.035,0,58.503-15.49,75.133-39.129C272.631,496.51,300.099,512,331.133,512
			c50.635,0,91.828-41.194,91.828-91.828c0-2.788-0.14-5.565-0.39-8.327c43.412-11.429,75.522-51.016,75.522-97.967
			c0-20.919-6.382-41.025-18.185-57.919C491.365,239.549,498.095,219.608,498.095,198.122z M239.304,343.088v77.084
			c0,32.221-26.216,58.437-58.437,58.437c-32.223,0-58.437-26.216-58.437-58.437c0-1.771,0.088-3.532,0.245-5.284
			c25.807-1.92,50.123-13.714,67.616-33.029l-24.749-22.417c-12.857,14.195-31.206,22.337-50.343,22.337
			c-37.442,0-67.902-30.461-67.902-67.901c0-11.892,3.075-23.392,8.834-33.519c16.639,11.985,37.042,19.055,59.068,19.055v-33.391
			c-37.442,0-67.902-30.461-67.902-67.901c0-31.399,21.722-58.325,51.228-65.815c10.151,20.567,27.843,37.177,50.093,45.523
			l11.728-31.264c-22.678-8.507-37.916-30.504-37.916-54.737c0-32.223,26.216-58.437,58.437-58.437s58.437,26.216,58.437,58.437
			v77.084v23.211h-13.79v-23.211h-33.391v23.211h-23.211v33.391h23.211v13.79h-23.211v33.391h23.211v13.789h-23.211v33.391h23.211
			v23.211h33.391v-23.211h13.79V343.088z M225.516,286.485v-60.969h60.969v60.969H225.516z M455.869,280.359
			c5.759,10.128,8.834,21.628,8.834,33.519c0,37.442-30.461,67.901-67.902,67.901c-19.137,0-37.486-8.141-50.343-22.337
			L321.71,381.86c17.494,19.314,41.809,31.107,67.616,33.029c0.157,1.751,0.245,3.513,0.245,5.284
			c0,32.223-26.216,58.437-58.437,58.437s-58.438-26.214-58.438-58.437v-77.084v-23.211h13.789v23.211h33.391v-23.211h23.211
			v-33.391h-23.211v-13.789h23.211v-33.391h-23.211v-13.79h23.211v-33.391h-23.211v-23.211h-33.391v23.211h-13.789v-23.211V91.828
			c0-32.223,26.216-58.437,58.437-58.437s58.437,26.214,58.437,58.437c0,24.232-15.238,46.229-37.916,54.737l11.728,31.264
			c22.251-8.347,39.942-24.957,50.094-45.523c29.506,7.491,51.228,34.416,51.228,65.815c0,37.441-30.461,67.901-67.902,67.901
			v33.391C418.827,299.414,439.23,292.343,455.869,280.359z"/>
	</g>
</g>
</svg>

  
];
